<template>
  <div>
    <SMTable />
  </div>
</template>

<script>
import SMTable from '../../components/SpiritualMultiplication/Table';

export default {
    components: {
        SMTable,
    },
};
</script>
